import { render, staticRenderFns } from "./PskInput.vue?vue&type=template&id=06a3fa4c&"
import script from "./PskInput.vue?vue&type=script&lang=js&"
export * from "./PskInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports